'use strict';

/**
 * [CHART_METADATA The chart metadata; titles,axis names and colors for the charts.]
 * @type {Object}
 */
module.exports = {
    CHART_METADATA: {
        CUSTOMER_TREND: {
            YAXIS_TEXT: 'No. of Customers',
            TITLE: 'Customer Trend',
            TOOLTIP: 'The chart shows the total number of customers in the system on a given day/week/month ' +
            'based on the specified duration. The chart shows the average number of customers for ' +
            'a week or for a month when the duration specified is 12 weeks or 12 months respectively.'
        },
        DEVICE_TREND: {
            YAXIS_TEXT: 'No. of Access Points',
            TITLE: 'Total Access Points',
            TOOLTIP: 'The chart shows the total number of active Access Points and inactive Access Points in ' +
            'the system on a given day/week/month based on the specified duration. ' +
            'The chart shows the average number of active/inactive Access Points for a week or ' +
            'for a month when the duration specified is 12 weeks or 12 months respectively.'
        },
        NEW_CUSTOMER_TREND: {
            YAXIS_TEXT: 'No. of Customers',
            TITLE: 'New Customers',
            TOOLTIP: 'The chart shows the number of new customers created in the system on a given ' +
            'day/week/month based on the specified duration.'
        },
        NEW_DEVICE_TREND: {
            YAXIS_TEXT: 'No. of Access Points',
            TITLE: 'New Access Points',
            TOOLTIP: 'The chart shows the number of new active and inactive Access Points in the system ' +
            'on a given day/week/month based on the specified duration. The Access Point must connect to ' +
            'the cloud at least once to be included in this chart. For weekly and monthly data, an Access Point ' +
            'is accounted for only once and not for each day of the week or month for which it was active/inactive.'
        },
        GUEST_CORPORATE_DATA_TREND: {
            YAXIS_TEXT: 'Data Usage',
            TITLE: 'Guest vs Corporate Data Usage',
            TOOLTIP: 'The chart shows the total data usage (transmitted and received) by clients over Guest and ' +
            'Corporate SSIDs on a given day/week/month based on the specified duration.'
        },
        TOP_CUSTOMERS_USING_DATA: {
            YAXIS_TEXT: 'Data usage',
            TITLE: 'Top 5 Customers by Data Usage',
            TOOLTIP: 'The chart shows the top five customers based on total data usage (transmitted and received) ' +
            'over Guest and Corporate SSIDs on a given day/week/month based on the specified duration. The chart ' +
            'shows the data usage values for Guest, Corporate, and Total.'
        },
        FEATURE_USAGE_TREND: {
            YAXIS_TEXT: 'No of SSIDs',
            TITLE: 'Feature Usage Trend',
            TOOLTIP: 'The chart shows, for each feature, the total number of SSIDs that have the feature configured on ' +
            'a given day/week/month based on the specified duration. The chart considers all SSIDs that were applied on ' +
            'any device template. The chart shows the average number of SSIDs for a week or for a month when the ' +
            'duration specified is 12 weeks or 12 months respectively.'
        },
        FEATURES_BY_CUSTOMERS: {
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            TITLE: 'Feature Usage by Customers',
            TOOLTIP: 'The chart shows, for each feature, the percentage of customers that have configured the feature ' +
            'in any of their SSIDs. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        FEATURES_BY_PERCENT_CUSTOMERS: {
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            TITLE: 'Wi-Fi Pro Network Feature Enablement',
            TOOLTIP: 'The chart shows for each feature the percentage of customers that have configured the feature in any of their SSIDs as of date, except Guest Insights. For Guest Insights, data for the last 30 days is considered. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        UNIQUE_CONNECTIONS_BY_CUSTOMERS: {
            YAXIS_TEXT: 'Average Unique Connections',
            TITLE: 'Average Unique Connections',
            TOOLTIP: 'The chart shows the average number of public unique connections and private unique connections as of date. The average public/private unique connections is obtained by dividing the total number of public/private unique connections by the total number of customers. A unique connection is identified by the MAC address connecting to the Wi-Fi network.'
        },
        DATA_BY_CUSTOMERS:{
            YAXIS_TEXT: 'Total Data',
            TITLE: 'Aggregate Throughput',
            TOOLTIP: 'The chart shows the total data usage (transmitted and received) by clients over Guest SSIDs and Corporate SSIDs on a given day/week/month/quarter/year based on the specified duration. You can also specify a custom duration. Data usage over Guest SSIDs is classified as Public Data and that over Corporate SSIDs as Private Data.'
        },
        PLUGIN_USAGE_TREND: {
            YAXIS_TEXT: 'No. of Active Portals',
            TITLE: 'Plugin Configuration Trend',
            TOOLTIP: 'The chart shows, for each plugin, the total number of active portals that have the plugin configured ' +
            'on a given day/week/month based on the specified duration. The chart shows the average number of active ' +
            'portals for a week or for a month when the duartion specified is 12 weeks or 12 months respectively.'
        },
        CUSTOMERS_BY_PLUGINS: {
            TITLE: 'Plugin Usage by Customers',
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            TOOLTIP: 'The chart shows, for each plugin, the percentage of customers that have configured the plugin in ' +
            'any of their active portals. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        CUSTOMER_SSID_COUNT: {
            TITLE: 'Customers by SSID Count',
            BUCKETS: [0, 1, 2, 3, 4],
            TOOLTIP: 'The pie chart shows the customer distribution based on the number of SSIDs they have used. The ' +
            'chart only considers SSIDs that have been applied on a device template.'
        },
        CUSTOMER_SSID_PROFILE: {
            TITLE: 'Customers by Network Type',
            TOOLTIP: 'The pie chart shows the percentage and number of customers who have used no SSIDs, only Guest SSIDs,' +
            ' only Corporate SSIDs, and both Guest and Corporate SSIDs. The chart only considers SSIDs that have been ' +
            'applied on a device template.'
        },
        CUSTOMER_BY_CELL_COUNT:{
            TITLE: 'Customers by Cell Count',
            BUCKETS: [0, 1, 2, 3],
            TOOLTIP: 'The pie chart shows the customer distribution based on the number of cells they have used. The ' +
            'cells are the average number of devices managed by the customers per location. All the leaf nodes of the location tree are ' +
            'considered for calculating the locations.'  
       },
        CUSTOMER_BY_LOCATION_COUNT: {
            TITLE: 'Customers by Sites',
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            XAXIS_TEXT: 'No. of Sites',
            TOOLTIP: 'The chart shows the percentage of customers based on the number of sites they have access for ' +
            'the selected site range. The chart considers only the leaf nodes (folder) of the location tree. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        CUSTOMER_BY_DEVICE_COUNT: {
            TITLE: 'Customers by Access Points',
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            XAXIS_TEXT: 'No. of Access Points',
            TOOLTIP: 'The chart shows the percentage of customers based on the number of managed Access Points they have for ' +
            'the selected Access Point range. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        CUSTOMER_BY_PORTAL_COUNT: {
            TITLE: 'Customers by Portal Count',
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            XAXIS_TEXT: 'No. of Portals',
            TOOLTIP: 'The chart shows the percentage of customers based on the number of active portals they have created ' +
            'for the selected portal range. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        CUSTOMER_BY_PLUGIN_COUNT: {
            TITLE: 'Customers by Plugin Count',
            YAXIS1_TEXT: '% of Customers',
            YAXIS2_TEXT: 'No. of Customers',
            XAXIS_TEXT: 'No. of Plugins',
            TOOLTIP: 'The chart shows the percentage of customers based on the number of plugins they have configured. The percentage value is calculated by considering only those customers to whom the corresponding services are assigned.'
        },
        AUTHENTICATION_NO_DATA_MESSAGE: 'There is no Customer Data'
    },
    OTHER_MESSAGES: {
        zeroData: 'Data for Customers is not available.',
        errorInApiCall: 'Failed to fetch data for the chart.',
        noChartToDisplay: 'There is no data to display since all legends are disabled.'
    },
    FILTERS: {
        DURATION: {
            name: 'Duration',
            choices: {
                week: '7 Days',
                month: '30 Days',
                quarter: '12 weeks',
                year: '12 months',
                thisMonth: 'This Month',
                custom: 'Custom'
            }
        },
        INTERVAL: {
            name: 'Range'
        },
        DATE: {
            name: 'Date',
            choices: {
                latest: 'Latest',
                custom: 'Custom'
            }
        }
    }
};